import * as React from 'react';

/**
 * Phosphor "ShootingStar" — the "Live sessions" value-prop row on the Live
 * Readings waitlist page (Figma 4389:27705). HORO-10471.
 */
const ShootingStarIcon = ({ className, ...props }) => {
    return (
        <svg className={className} {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.6 4.4L15.44 8.13L19.56 8.73L16.58 11.63L17.28 15.73L13.6 13.79L9.91 15.73L10.62 11.63L7.64 8.73L11.75 8.13L13.6 4.4Z"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7 15.5L4 18.5" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6 10.5L3.5 13" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.5 18L9 20.5" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default ShootingStarIcon;
